import { render, staticRenderFns } from "./SelectionExtraService.vue?vue&type=template&id=71a085fe&"
import script from "./SelectionExtraService.vue?vue&type=script&lang=js&"
export * from "./SelectionExtraService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports